import { htmlToText } from '../utils/dom';

/**
 * Load tooltip RTE command.
 */
export default (editor, opts = {}) => {
  editor.on('rte:enable', (view) => {
    const rte = editor.RichTextEditor;

    if (!rte || rte.get('tooltip')) return;

    rte.add('tooltip', {
      icon: '<svg viewBox="0 0 24 24" style="width: 16px; height: 16px;"><path fill="currentColor" d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18V8Z"></path></svg>',
      attributes: { title: 'Add tooltip' },
      result: (rte) => {
        const textSelection = rte.selection();
        if (!textSelection) {
          alert('Highlight the text you want to turn into a tooltip.');
          return;
        }

        const selectedText = textSelection.toString();
        if (!selectedText.trim()) {
          alert('The selection is empty. Highlight some text first.');
          return;
        }

        const escapedText = htmlToText(selectedText);
        rte.insertHTML(`<a data-bs-toggle="tooltip" data-bs-content="${escapedText}" data-gjs-type="tooltip">${escapedText}</a>`);

        rte.disable();
      }
    });
  });
};
